/**
 * A user's preferred ship-to address order is stored as a single flat list of
 * composite ids (`${accountId}-${addressId}`) in user preferences (the field
 * is still named `favoriteShipToAddressIds` for backend compatibility — it
 * predates ordering, when it held capped "favorites"). Entries of different
 * accounts interleave freely.
 *
 * One account's display order: the account's ids present in the stored list
 * (in stored order) first, then the account's remaining ids in their natural
 * order. Legacy partial favorites data therefore still reads correctly — the
 * former favorites simply lead the list.
 */
export const getOrderedAccountAddressIds = (
  accountAddressUniqueIds: readonly string[],
  storedOrderedIds: readonly string[] | undefined | null,
): string[] => {
  if (!storedOrderedIds?.length) {
    return [...accountAddressUniqueIds];
  }

  const stored = storedOrderedIds.filter((id) =>
    accountAddressUniqueIds.includes(id),
  );

  return [
    ...stored,
    ...accountAddressUniqueIds.filter((id) => !stored.includes(id)),
  ];
};
